import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";

const VerifyPayments = () => {
  const [tickets, setTickets] = useState([]);

  const thStyle = {
    padding: "10px",
    textAlign: "center",
    fontWeight: "bold",
    color: "#333",
    backgroundColor: "#f8f8f8",
  };

  const tdStyle = {
    padding: "10px",
    textAlign: "center",
    color: "#333",
    borderBottom: "1px solid #4f1414",
  };

  useEffect(() => {
    const fetchTickets = async () => {
      const querySnapshot = await getDocs(collection(db, "ticketPurchases"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTickets(data);
    };

    fetchTickets();
  }, []);

  const handleVerify = async (ticketId) => {
    const ticketRef = doc(db, "ticketPurchases", ticketId);
    await updateDoc(ticketRef, {
      paymentStatus: "verified",
    });

    alert("Payment verified!");

    // Refresh ticket list
    const querySnapshot = await getDocs(collection(db, "ticketPurchases"));
    const updatedTickets = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setTickets(updatedTickets);
  };

  return (
 <div className="responsive-table">
      <h1 style={{ textAlign: "center", color: "#333" }}>Verify Ticket Payments</h1>
      <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
        <thead style={{ backgroundColor: "#e0e0e0" }}>
          <tr>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Email</th>
            <th style={thStyle}>Contact</th>
            <th style={thStyle}>Tickets</th>
            <th style={thStyle}>Total</th>
            <th style={thStyle}>Payment</th>
            <th style={thStyle}>Proof</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket) => (
            <tr key={ticket.id}>
              <td style={tdStyle}>{ticket.buyerName}</td>
              <td style={tdStyle}>{ticket.buyerEmail}</td>
              <td style={tdStyle}>{ticket.buyerContact}</td>
              <td style={tdStyle}>{ticket.ticketCount}</td>
              <td style={tdStyle}>₱{ticket.totalPrice}</td>
              <td style={tdStyle}>{ticket.paymentMethod}</td>
              <td style={tdStyle}>
                <a href={ticket.proofOfPayment} target="_blank" rel="noopener noreferrer">
                  <img
                    src={ticket.proofOfPayment}
                    alt="Proof"
                    style={{ width: "140px", borderRadius: "5px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}
                  />
                </a>
              </td>
              <td style={tdStyle}>
                {ticket.paymentStatus === "verified" ? (
                  <span style={{ color: "#4caf50", fontWeight: "bold" }}>Verified</span>
                ) : (
                  <span style={{ color: "#ff9800", fontWeight: "bold" }}>Pending</span>
                )}
              </td>
              <td style={tdStyle}>
                {ticket.paymentStatus !== "verified" && (
                  <button
                    onClick={() => handleVerify(ticket.id)}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#4caf50",
                      border: "none",
                      color: "white",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                >
                  Verify
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
};

export default VerifyPayments;



